export const formatEUI = (eui: string, joinBy = ' ') => {
  if (!eui) return eui
  const euiArr = eui.trim().split(' ').join('').match(/.{2}/g)

  if (!euiArr) return eui

  return euiArr.join(joinBy).toUpperCase()
}
